import { render } from "./DoubleBounceLoader.vue?vue&type=template&id=b9815266&scoped=true"
import script from "./DoubleBounceLoader.vue?vue&type=script&lang=js"
export * from "./DoubleBounceLoader.vue?vue&type=script&lang=js"

import "./DoubleBounceLoader.vue?vue&type=style&index=0&id=b9815266&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9815266"]])

export default __exports__